import { supabase } from './supabase';
import { ArticleGenerationSettingsRow, CriticShortlistRow } from '../types/articleGeneration';

export const criticModelsService = {
  listModels: async (): Promise<{ id: string; name: string }[]> => {
    const { data, error } = await supabase.functions.invoke('openrouter-models', { body: {} });
    if (error) throw error;
    return data.models ?? [];
  },

  listShortlist: async (companyId: string): Promise<CriticShortlistRow[]> => {
    const { data, error } = await supabase
      .from('critic_model_shortlist')
      .select('*')
      .eq('company_id', companyId)
      .order('created_at', { ascending: true });
    if (error) throw error;
    return (data ?? []) as CriticShortlistRow[];
  },

  addToShortlist: async (companyId: string, modelId: string, label: string): Promise<void> => {
    const { error } = await supabase
      .from('critic_model_shortlist')
      .insert({ company_id: companyId, model_id: modelId, label });
    if (error) throw error;
  },

  removeFromShortlist: async (id: string): Promise<void> => {
    const { error } = await supabase.from('critic_model_shortlist').delete().eq('id', id);
    if (error) throw error;
  },

  assignSlot: async (companyId: string, id: string, slot: number | null): Promise<void> => {
    if (slot !== null) {
      const { error: clearError } = await supabase
        .from('critic_model_shortlist')
        .update({ critic_slot: null })
        .eq('company_id', companyId)
        .eq('critic_slot', slot);
      if (clearError) throw clearError;
    }
    const { error } = await supabase
      .from('critic_model_shortlist')
      .update({ critic_slot: slot })
      .eq('id', id);
    if (error) throw error;
  },

  getSettings: async (companyId: string): Promise<ArticleGenerationSettingsRow | null> => {
    const { data, error } = await supabase
      .from('article_generation_settings')
      .select('*')
      .eq('company_id', companyId)
      .maybeSingle();
    if (error) throw error;
    return data as ArticleGenerationSettingsRow | null;
  },

  upsertSettings: async (
    companyId: string,
    patch: Partial<Omit<ArticleGenerationSettingsRow, 'company_id'>>
  ): Promise<void> => {
    const { error } = await supabase
      .from('article_generation_settings')
      .upsert({ company_id: companyId, ...patch });
    if (error) throw error;
  },
};
